module.exports = __webpack_public_path__ + "static/pic04-1609dea61acb9e992d846c586683a226.jpg";